module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if ( typeof days === "undefined" ) { 
__p+='\n\n	Bitte wählen Sie einen Zeitraum aus, um Preise zu erhalten.\n\n';
 } else { 
__p+='\n\n<div class="controls">\n	<span class="pricetable-info">'+
((__t=( info ))==null?'':__t)+
'</span>\n\n	<div class="right button offset-up" data-days="7" ';
 if ( !canGoFurther ) print('disabled') 
__p+='>&gt;&gt;</div>\n	<div class="right button offset-up" data-days="1" ';
 if ( !canGoFurther ) print('disabled') 
__p+='>&gt;</div>\n	';
 if ( developer ) { 
__p+='<div class="right button offset-up" data-days="1" ';
 if ( !canGoFurther ) print('disabled') 
__p+='>+1d</div>';
 } 
__p+='\n\n\n	<div class="right button btn-reset">'+
((__t=( __('today') ))==null?'':__t)+
'</div>\n\n	';
 if ( developer ) { 
__p+='<div class="right button offset-down" data-days="1" '+
((__t=( renderOffset === 0 ? 'disabled' : '' ))==null?'':__t)+
'>-1d</div>';
 } 
__p+='\n	<div class="right button offset-down" data-days="1" '+
((__t=( renderOffset === 0 ? 'disabled' : '' ))==null?'':__t)+
'>&lt;</div>\n	<div class="right button offset-down" data-days="7" '+
((__t=( renderOffset === 0 ? 'disabled' : '' ))==null?'':__t)+
'>&lt;&lt;</div>\n\n	<div class="clear"></div>\n</div>\n\n<table>\n	<thead>\n		<tr>\n			<th>&nbsp;</th>\n			';
 _.each(days, function(day) { 
__p+='\n				<th class="day_'+
((__t=( day.index ))==null?'':__t)+
' ';
 if ( selectedNightString == day.date ) print('highlight') 
__p+=' ';
 if ( day.weekend ) print('weekend') 
__p+='">\n					'+
((__t=( day.line1 ))==null?'':__t)+
'<br>\n					<b>'+
((__t=( day.line2 ))==null?'':__t)+
'</b>\n				</th>\n			';
 }) 
__p+='\n		</tr>\n	</thead>\n\n	<tbody>\n		';
 _.each(groups, function (group) { 
__p+='\n		<tr>\n			<td class="divider" colspan="'+
((__t=( renderDaysCount + 1 ))==null?'':__t)+
'">'+
((__t=( group.title ))==null?'':__t)+
'</td>\n		</tr>\n\n			';
 _.each(group.offers, function (offer) { 
__p+='\n				<tr>\n					<td class="kat">\n						<b>'+
((__t=( offer.title ))==null?'':__t)+
'</b>\n						<br/>'+
((__t=( offer.subtitle ))==null?'':__t)+
'\n					</td>\n					';
 _.each(days, function(day, i) { 
__p+='\n						';
 var value = offer.values[i] 
__p+='\n						';
 var display_value = offer.values_display[i] 
__p+='\n						';
 if ( display_value === "" ) { 
__p+='\n						<td class="na ';
 if ( day.weekend ) print('weekend') 
__p+=' ';
 if ( day.selected ) print('highlight') 
__p+='">&times;</a></td>\n						';
 } else { 
__p+='\n						<td class="ok ';
 if ( day.weekend ) print('weekend') 
__p+=' ';
 if ( day.selected ) print('highlight') 
__p+='">\n							<a href="#"\n							  class="price"\n							  data-class="'+
((__t=( offer.class ))==null?'':__t)+
'"\n							  data-client="'+
((__t=( offer.client ))==null?'':__t)+
'"\n							  data-item="'+
((__t=( offer.item ))==null?'':__t)+
'"\n							  data-url="'+
((__t=( offer.url ))==null?'':__t)+
'"\n							  data-from="'+
((__t=( day.date ))==null?'':__t)+
'"\n							>\n								';
 if ( value < 0 ) { 
__p+='ab<br>';
 } 
__p+='\n								'+
((__t=( display_value ))==null?'':__t)+
'\n							</a>\n						</td>\n						';
 } 
__p+='\n					';
 }) 
__p+='\n				</tr>\n\n			';
 }) 
__p+='\n		';
 }) 
__p+='\n	</tbody>\n\n</table>\n\n';
 } 
__p+='\n';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/reserva/templates/miniengine/pricetable-template.html
// module id = 73
// module chunks = 0